import React from 'react';
import { ArrowRight } from 'lucide-react';
import Button from '../components/Button';

// §7.4.2 — card: image top, title, body, "Read the study →" button (opens modal).
export default function ResearchCard({ item, onOpen }) {
  return (
    <article className="research-card">
      <div className="research-card__media">
        <img src={item.image} alt={item.title} loading="lazy" />
      </div>
      <div className="research-card__body">
        <h3 className="research-card__title">{item.title}</h3>
        <p className="research-card__text">{item.body}</p>
        <Button variant="dark" onClick={() => onOpen(item)} className="research-card__btn">
          {item.ctaLabel || 'Read the study'}
          <ArrowRight size={16} />
        </Button>
      </div>
    </article>
  );
}
